import React from 'react'
import './Style/Report.css'
function Report({subTotal,discount,lastPrice,product}) {


  return <div className='report-info'>
      <div className='info'>
          <div className='data-report'>
            <p className='infoproduct'> Sub Total </p>
            <span className='infoproduct'> ${subTotal} </span>
          </div>
          <div className='data-report'>
            <p className='infoproduct'> Discount({product.discount}%) </p>
            <span className='infoproduct'> ${discount} </span>
          </div>
          <div className='total'>
            <p className='grand-total'> Grand Total : </p>
            <span className='infoproduct' style={{color : '#fff'}}> ${lastPrice} </span>
          </div>
      </div>

    <h1 className='note'> NOTE: </h1>
    <p className=' lead'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur accusantium eaque, itaque possimus illo est id dolorum blanditiis cupiditate aliquid modi, minima hic nemo officiis veniam. Quia nulla quaerat eos? </p>
    <p className='thanks'> Thank you For Your Business </p>
  </div>
}

export default Report